export default __webpack_public_path__ + "static/media/guitar_line_icon.fd45c1d0.png";